/// <amd-module name="Search/WorkItem/Flux/Stores/PreviewNotificationStore" />
import * as VSSStore from "VSS/Reflux/Store";

export interface IPreviewNotificationStoreState {
    workItemPreviewBannerState: WorkitemPreviewPaneScenario;
}

export enum WorkitemPreviewPaneScenario {
    Stale,
    Deleted,
    None
}

export class PreviewNotificationStore extends VSSStore.Store {
    protected _state: IPreviewNotificationStoreState = { workItemPreviewBannerState: WorkitemPreviewPaneScenario.None };

    public get state(): IPreviewNotificationStoreState {
        return this._state;
    }

    public showWorkItemPreviewBanner = (scenario: WorkitemPreviewPaneScenario): void => {
        this._state.workItemPreviewBannerState = scenario;
        this.emitChanged();
    }

    public dismissWorkItemPreviewBanner = (): void => {
        this._state.workItemPreviewBannerState = WorkitemPreviewPaneScenario.None;
        this.emitChanged();
    }
}